export const VOICE_CAST_VERSION = 'qwen-voicedesign-v1-20260905';

export const VOICE_CAST: Record<string, { label: string; seed: number }> = {
  apprentice: { label: '明亮溫柔的少女學徒', seed: 10821 },
  keeper: { label: '溫潤沉穩的竹林棋士', seed: 28117 },
  strategist: { label: '自信俐落的女性策士', seed: 62033 },
  weaver: { label: '冷靜神祕的霧中棋師', seed: 82091 },
  guardian: { label: '厚實威嚴的雲門宗師', seed: 100003 },
};
